import React from "react";
import { Link } from "react-router-dom";
import s from "./style.module.scss";
import Scan from "shared/icons/Scan";
import { redirectToScanApp } from "shared/lib/redirectToScanApp";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";

const ScanButton: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);
  return (
    <>
      {user_info && (
        <button
          onClick={() => redirectToScanApp(user_info.msisdn)}
          className={s.scan}
        >
          <Scan />

          <span>Сканировать чек</span>
        </button>
      )}
    </>
  );
};

export default ScanButton;
